export default __webpack_public_path__ + "static/media/edit.0c7c2f4f.svg";